import React, { useEffect, useState } from "react";
import { Alert, Spin, Table } from "antd";
import { fetchSprTovRests } from "./spr-tov-api";

const pick = (row, ...keys) => {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null) return row[key];
  }
  return undefined;
};

const SprTovRests = ({ idTov }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    fetchSprTovRests(idTov)
      .then((data) => {
        if (cancelled) return;
        const items = Array.isArray(data) ? data : pick(data, "items", "Items") || [];
        setRows(
          items.map((row, index) => ({
            key: String(pick(row, "idSkl", "IdSkl") ?? index),
            idSkl: Number(pick(row, "idSkl", "IdSkl")),
            sklName: pick(row, "sklName", "SklName") ?? "",
            kol: Number(pick(row, "kol", "Kol") ?? 0)
          }))
        );
      })
      .catch((e) => {
        if (!cancelled) setError(e.message || "Не удалось загрузить остатки");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [idTov]);

  if (error) return <Alert type="error" showIcon message={error} />;
  if (loading) {
    return (
      <div className="spr-tov-card__body spr-tov-card__body--stub">
        <Spin />
      </div>
    );
  }
  return (
    <Table
      size="small"
      rowKey="key"
      pagination={false}
      dataSource={rows}
      columns={[
        { title: "Склад", dataIndex: "sklName", key: "sklName", ellipsis: true },
        {
          title: "Количество",
          dataIndex: "kol",
          key: "kol",
          width: 140,
          align: "right",
          render: (value) => value.toLocaleString("ru-RU", { maximumFractionDigits: 3 })
        }
      ]}
      locale={{ emptyText: "Остатков нет" }}
    />
  );
};

export default SprTovRests;
